<template>
  <div class="project-item-routes full-routes"
       v-if="list.length > 0">
    <bread-icon class="icon"></bread-icon>
    <div @click="show = true"
         @mouseleave="show = false"
         class="link-list">
      <dots-icon class="dots"></dots-icon>
      <transition name="fade">
        <ul class="links-list_inner"
            v-if="list.length"
            v-show="show">
          <router-link tag="li"
                       v-for="link in list"
                       :key="'link' + link.id"
                       :to="setLink(link)"
                       class="link-name_inner">
            <span v-if="link && link.name">
              <trim-item :string="link.name"
                         :width="30"></trim-item>
            </span>
          </router-link>
        </ul>
      </transition>
    </div>
  </div>
</template>

<script>
  import {breadcrumbsMixin} from "../../../../mixins/sidebar/breadcrumbsMixin";
  import {mapState} from 'vuex'

  export default {
    name: 'projectItemThingsRoutes',
    mixins: [breadcrumbsMixin],
    computed: {
      ...mapState({
        projects: state => state.projects.allProjects
      }),
      list() {
        let itemTree;
        let breadcrumbs = [];

        if (this.projects) {
          findItemTree(this.projects, this.routeItem);

          if (itemTree) {
            addParent();

            findTheWay(itemTree.items, this.routeItem, itemTree.id);
            breadcrumbs = this.delDouble(breadcrumbs, 'id');
            breadcrumbs.pop();
          }
        };

        return breadcrumbs;


        function findItemTree(projects, routeItem) {
          for (let item of projects) {
            item = JSON.stringify(item);
            if  (item.includes(`"id":${routeItem}`)) {
              itemTree = JSON.parse(item);
              break;
            }
          };
        };

        function addParent() {
          breadcrumbs.push({
            id: itemTree.id,
            name: itemTree.name,
            mother: true,
            motherId: itemTree.id
          })
        };

        function findTheWay(arr,routeId, motherId) {
          findWay(arr);

          function findWay(a) {
            for (let item of a) {
              let itemString = JSON.stringify(item);

              if (item.id == routeId) {
                breadcrumbs.push({id: item.id,
                  name: item.name,
                  mother: false,
                  motherId: motherId});
                break;
                return;
              };

              if ( itemString.includes(`"id":${routeId}`)) {
                breadcrumbs.push({id: item.id,
                  name: item.name,
                  mother: false,
                  motherId: motherId});
                findWay(item.items);
              }
            }
          }
        };
      }
    },
    methods: {
      setLink(link) {
        if (link.mother) {
          return `/things/project/${link.id}`
        } else {
          return `/things/project/${link.motherId}/project-item/${link.id}`
        }
      }
    }
  }
</script>

<style lang="scss" scoped>

</style>
